import classNames from 'classnames';

import '/assets/styles/partials/info-box.scss';

const InfoBox = ({ children, title, plain, className }) => {
	return (
		<div className={classNames('infobox', className, { plain })}>
			{title && <strong className="infobox-title">{title}</strong>}
			{children}
		</div>
	);
};

export default InfoBox;
